import React from "react";
import BaseComponent from "../../common/BaseComponent";
import { Table } from "antd";
import { RetrunReasonLogInput } from "../input";
import "./style/index.scss";

export default class RequestReasonLogTable extends BaseComponent {
  constructor(props: any) {
    super(props);
    this.state = {
      dataSource: [],
    };
    // @ts-ignore
    this.columns = [
      {
        title: "Submitted Date",
        dataIndex: "submittedDate",
        key: "submittedDate",
        width: "16.75rem",
      },
      {
        title: "Submitted By",
        dataIndex: "submittedBy",
        key: "submittedBy",
        width: "17rem",
      },
      {
        title: "Reason",
        dataIndex: "reasonColumn",
        key: "reasonColumn",
        className: "returnReasonColumn",
        render: (text: any) => (
          <RetrunReasonLogInput value={text} ref={this.props.reasonRef} readonly="readonly" />
        ),
      },
    ];
  }

  render() {
    return (
      <div className="returnReasonLogTable">
        {/* @ts-ignore */}
        <Table
          key={this.props.tableKey}
          className="antTable"
          dataSource={this.props.dataSource}
          columns={(this as any).columns}
          pagination={false}
        />
      </div>
    );
  }
}
